module.exports = __webpack_public_path__ + "img/tpc-web-11.e3e2541e.jpg";